import { useLocation, useNavigate } from 'react-router-dom';

import { loginLogic, toastLogic } from '@_features/auth';
import { LogClick } from '@_features/log';
import { FolderStrokeIcon, DashBoardIcon, LinkButtonIcon } from '@_shared/icons';
import { eventPush } from '@_shared/libs';
import { Typography } from '@_shared/ui/Typography';

import * as S from './BottomNavigationBar.style';

const navItems = [
	{
		title: '폴더',
		icon: <FolderStrokeIcon />,
		path: '/',
	},
	{
		icon: <LinkButtonIcon />,
		path: '/content/create',
	},
	{
		title: '전체',
		icon: <DashBoardIcon />,
		path: '/folder/all',
	},
];

function isPathMatches(path: string, pathname: string) {
	if (path === '/') {
		return !!(
			(pathname === '/' || pathname.startsWith('/folder')) &&
			pathname !== '/folder/all'
		);
	}
	return !!pathname.startsWith(path);
}

export function BottomNavigationBar() {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	return (
		<S.NavigationBar>
			{navItems.map((navItem) => {
				if (navItem.title !== undefined) {
					const isCurrentPath = isPathMatches(navItem.path, pathname);

					return (
						<LogClick params={{ button: `네비게이션-${navItem.title}-클릭` }}>
							<S.NavigationBarItem
								isHighlight={isCurrentPath}
								key={`${navItem.path} Item`}
								onClick={() => {
									if (loginLogic.isLogin()) {
										eventPush(`${navItem.title}.nav.click`);
										navigate(navItem.path);
									} else {
										toastLogic.loginToast();
									}
								}}
							>
								{navItem.icon}
								<Typography
									type="label-medium"
									color={isCurrentPath ? 'orange-primary' : 'warmgray-300'}
								>
									{navItem.title}
								</Typography>
							</S.NavigationBarItem>
						</LogClick>
					);
				}
				return (
					<S.NavigationIconItem
						key={`${navItem.path} Item`}
						onClick={() => {
							if (loginLogic.isLogin()) {
								navigate(navItem.path);
							} else {
								toastLogic.loginToast();
							}
						}}
					>
						{navItem.icon}
					</S.NavigationIconItem>
				);
			})}
		</S.NavigationBar>
	);
}
